import React from 'react'
import PropTypes from 'prop-types'
import { propType } from 'graphql-anywhere'
import ModalContainer from '../../../modal-container'

import ViewDownloadsTable from './view-downloads-table'

import DEVICE_FRAGMENT from '../../../../../graphql/fragments/device.gql'

import styles from './view-downloads-modal.css'

const CloseIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 0 L24 24z" />
    <path d="M24 0 L0 24z" />
  </svg>
)

CloseIcon.propTypes = {
  className: PropTypes.string.isRequired
}

const ViewDownloadsModal = ({
  onModalClose,
  ...rest
}) => {
  return (
    <ModalContainer
      onRequestClose={onModalClose}
      shouldCloseOnOverlayClick
    >
      <div className={styles.headline}>
        <button className={styles.modalCloseIcon} onClick={onModalClose}>
          <CloseIcon className={styles.closeIcon} />
        </button>
      </div>
      <div className={styles.viewDownloadsModalWrapper}>
        <h2 className={styles.header}>Downloads</h2>
        <ViewDownloadsTable {...rest} />
      </div>
    </ModalContainer>
  )
}

ViewDownloadsModal.propTypes = {
  onModalClose: PropTypes.func.isRequired,
  devices: PropTypes.arrayOf(propType(DEVICE_FRAGMENT)).isRequired,
  selectedDeviceUuid: PropTypes.string.isRequired
}

export default ViewDownloadsModal
